export class IncomingSMSApiService {
	constructor(CoreApi) {
		this.CoreApi = CoreApi;
	}
	get(id) {
		return this.CoreApi.makeApiCall("POST", "incoming_sms/get/", null, {id: id}).then(r => r.data);
	}
	list(params) {
		return this.CoreApi.makeApiCall("POST", "incoming_sms/list/", params).then(r => r.data);
	}
	delete(numbers) {
		return this.CoreApi.makeApiCall("POST", "incoming_sms/delete/", null, {numbers: JSON.stringify(numbers)}).then(r => r);
	}
	create(data) {
		return this.CoreApi.makeApiCall("POST", "incoming_sms/save/", null, {data: JSON.stringify(data)}).then(r => r);
	}
	update(rows) {
		return this.CoreApi.makeApiCall("POST", "incoming_sms/update/", null, {data: JSON.stringify(rows)}).then(r => r);
	}
}